/* eslint react/prop-types: 0 */
import React, { Fragment } from "react";

import SearchProperties from "../../../common/SearchProperties";
import {
  getTranslatedValue,
  translateStatic,
} from "../../../helpers/translationHelper";
import * as theme5Styles from "../scss/theme5.module.scss";

class PropertySearch extends SearchProperties {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      propertyTypes,
      propertyCategories,
      locale,
      defaultLocale,
    } = this.props;

    return (
      <Fragment>
        <div className={`${theme5Styles.searchColm}`}>
          <div className={theme5Styles.filterSearch}>
            <input
              type="text"
              className={theme5Styles.field}
              name="search"
              value={this.state.searchForm.search}
              onChange={this.handleInputChange}
            />
            <button
              className={theme5Styles.srch}
              onClick={() => this.searchProperties()}
            ></button>
          </div>
        </div>
        <div className={`${theme5Styles.filterC}`}>
          <div className={`${theme5Styles.filterRow}`}>
            <div className={theme5Styles.colm}>
              <select
                className={theme5Styles.field}
                name="type"
                value={this.state.searchForm.type}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("type", locale, defaultLocale)}
                </option>
                {(() => {
                  return propertyTypes.map((property_type) => {
                    return (
                      <option value={property_type.id} key={property_type.id}>
                        {getTranslatedValue(
                          property_type.translations,
                          "name",
                          locale,
                          defaultLocale
                        )}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
            <div className={theme5Styles.colm}>
              <select
                className={theme5Styles.field}
                name="category"
                value={this.state.searchForm.category}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("category", locale, defaultLocale)}
                </option>
                {(() => {
                  return propertyCategories.map((category) => {
                    return (
                      <option value={category.id} key={category.id}>
                        {getTranslatedValue(
                          category.translations,
                          "name",
                          locale,
                          defaultLocale
                        )}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
            <div className={theme5Styles.colm}>
              <select
                className={theme5Styles.field}
                name="bedrooms"
                value={this.state.searchForm.bedrooms}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("bedroom", locale, defaultLocale)}
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4+</option>
              </select>
            </div>
            <div className={theme5Styles.colm}>
              <select
                className={theme5Styles.field}
                name="bathrooms"
                value={this.state.searchForm.bathrooms}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("bathroom", locale, defaultLocale)}
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4+</option>
              </select>
            </div>
          </div>
          <div className={`${theme5Styles.filterBtns}`}>
            <button
              className={`${theme5Styles.btn} ${theme5Styles.btnSm} ${theme5Styles.btnDark}`}
              onClick={() => this.searchProperties()}
            >
              {translateStatic("filter", locale, defaultLocale)}
            </button>
            <button
              className={`${theme5Styles.btn} ${theme5Styles.btnSm}`}
              onClick={() => this.clearSearchForm()}
            >
              {translateStatic("clear", locale, defaultLocale)}
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PropertySearch;
